import React from "react";
import _ from "lodash";
import cx from "classnames";
import { connect } from "react-redux";

import PreGuess from "./screens/PreGuess";
import Guessing from "./screens/Guessing";
import Over from "./screens/Over";
import JoiningTOT from "./screens/JoiningTOT";

const TOTO = (props) => {
  const gameReducer = _.get(props, "gameReducer");
  const currentUser = _.get(gameReducer, "currentUser");
  const mobile_app = _.get(gameReducer, "mobile_app");
  const roomObj = _.get(gameReducer, "roomObj");
  const roomId = _.get(roomObj, "id");
  const users = _.get(roomObj, "users");
  const game_state = _.get(roomObj, "game_state");
  const active_player = _.get(game_state, "active_player");
  const word = _.get(game_state, "word");
  const right_words = _.get(game_state, "right_words");
  const skipped_words = _.get(game_state, "skipped_words");
  const category_image = _.get(game_state, "category_image");
  const current_category = _.get(game_state, "current_category");
  const player_score = _.get(game_state, "player_score");
  const status = _.get(game_state, "status");

  const lobby_params = _.get(props, "paramsReducer.gameObj.0_lobby");
  const preguess_params = _.get(props, "paramsReducer.gameObj.1_preguess");
  const guessing_params = _.get(props, "paramsReducer.gameObj.2_guessing");

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const currentGuesser = users?.find(
    (user) => user.player_id === active_player
  );
  const isGuesser = currentPlayer?.player_id === active_player;

  return (
    <div className="smallbites heightFull">
      <div
        className={cx("bingo-content-wrapper", {
          "playing-overflow-scroll": status === "Playing"
        })}
      >
        <section className="tot-new-main">
          {status === "JoiningTOT" && (
            <JoiningTOT users={users} lobby_params={lobby_params} />
          )}
          {status === "PreGuess" && (
            <PreGuess
              roomId={roomId}
              isGuesser={isGuesser}
              mobile_app={mobile_app}
              currentGuesser={currentGuesser}
              preguess_params={preguess_params}
            />
          )}
          {status === "Guessing" && (
            <Guessing
              word={word}
              users={users}
              roomId={roomId}
              isGuesser={isGuesser}
              mobile_app={mobile_app}
              right_words={right_words}
              skipped_words={skipped_words}
              category_image={category_image}
              currentGuesser={currentGuesser}
              guessing_params={guessing_params}
              current_category={current_category}
            />
          )}
          {status === "Over" && (
            <Over
              users={users}
              mobile_app={mobile_app}
              player_score={player_score}
            />
          )}
        </section>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

export default connect(mapStateToProps, null)(TOTO);
